import type { Transaction, CategorizationResult, CategorizationContext } from '../types';

/**
 * Base Categorizer Class
 * All categorizers must extend this class
 */
export abstract class BaseCategorizer {
  name: string;
  priority: number;

  constructor(name: string, priority: number = 50) {
    this.name = name;
    this.priority = priority; // Lower number = higher priority
  }

  /**
   * Categorize a transaction
   * @param transaction - Transaction object
   * @param context - Additional context (rules, history, etc.)
   * @returns Categorization result with category, confidence, and method
   */
  abstract categorize(
    transaction: Transaction,
    context?: CategorizationContext
  ): Promise<CategorizationResult>;

  /**
   * Check if this categorizer should be used
   * @param transaction - Transaction object
   * @param context - Additional context
   * @returns True if this categorizer can handle the transaction
   */
  canCategorize(transaction: Transaction, context: CategorizationContext = {}): boolean {
    return true;
  }

  /**
   * Get categorizer info
   * @returns Categorizer metadata
   */
  getInfo() {
    return {
      name: this.name,
      priority: this.priority
    };
  }
}
